const html = document.querySelector("html");
const body = document.querySelector(".body");

//====== Registerd ScrollTrigger Plugin ==========
gsap.registerPlugin(ScrollTrigger);

function hideLoader(){
  tl.to(".loader-upper",{
      y:"-100%",
      duration:0.8,
      ease: "sine.inOut",
  });
}

//========= LENIS START =========
const lenis = new Lenis({
  duration: 1,
  smooth:true,
  infinite: false,
  syncTouch:false, // mimic touch device scroll while allowing scroll sync (can be unstable on iOS<16)
  smoothTouch: false,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});

function raf(time){
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);
//========= LENIS END =========

//======= LENIS SCROLL CONTROL =========
let isOpened = false;
function stopLenisScroll(){
  lenis.stop();
  isOpened = true;
}

function startLenisScroll(){
  lenis.start();
  isOpened = false;
}

//========= SCROLL & NAVBAR TOGGLE START =========
const header = document.querySelector(".header");

// Header animation
let lastScroll = 0

lenis.on("scroll", ({scroll})=>{
  scroll > lastScroll ? header.classList.add("hidden") : header.classList.remove("hidden");
  lastScroll = scroll;
  // Sticky toggle (after 80px scroll)
  scroll > 80 ? header.classList.add("sticky") : header.classList.remove("sticky");
});
//========= SCROLL & NAVBAR TOGGLE END =========


//======= ACTIVE NAVIGATION LINK START =========
// const windowPathname = window.location.pathname;
// const navLinks = document.querySelectorAll(".navbar__link");

// navLinks.forEach(link =>{
//  const navLinkPathname = new URL(link.href, window.location.origin).pathname;
//  const isActiveLink = windowPathname === navLinkPathname || (windowPathname === "/index.html" && navLinkPathname === "/")
//   link.classList.toggle("active", isActiveLink);
// });

const sections = document.querySelectorAll("section");
const navLinks = document.querySelectorAll(".menu a");

let current = "";
function activeLink(){
  sections.forEach(section => {
    const sectionTop = section.offsetTop - 80; // adjust for header height
    const sectionHeight = section.clientHeight;

    if (pageYOffset >= sectionTop && pageYOffset < sectionTop + sectionHeight) {
      current = section.getAttribute("id");
    }
  });

  navLinks.forEach(link => {
    link.classList.remove("active");
    if (link.getAttribute("href") === "#" + current) {
      link.classList.add("active");
    }
  });
}
  
//======= ACTIVE NAVIGATION LINK END =========

//======= BANNER CONTENT ANIMATION START =========
function bannerContentsAnimation(){
  const tl = gsap.timeline();
  // Header Animation Start
  tl.from([".header__logo", ".header-btn"], {
    opacity: 0,
    y: 50,
    delay: 0.2,
    duration: 1,
    stagger:0.1,
    ease: Expo.easeInOut,
  });
  tl.from([".navbar__link", "#hamburger-btn",], {
      opacity:0,
      y:40,
      duration:0.8,
      stagger:0.1,
      delay:-1,
      ease:"power4.out",
    }
  );
  // Header Animation End

  tl.from(".hero-title", {
    opacity: 0,
    duration: 1,
    // y: 50,
    delay: -1.15,
    stagger:0.1,
    // ease: "power4.in",
  });
  const heroSubTitle = document.querySelector(".hero-subTitle");
  heroSubTitle && tl.from(heroSubTitle, {
    opacity: 0,
    duration: 1,
    y: 50,
    delay: -1.25,
    stagger:0.1,
    ease: "power4.out",
  });
  
  const heroBtns = document.querySelectorAll(".banner-btn");
  heroBtns && heroBtns.forEach((heroBtn)=>{
    tl.from(heroBtn, {
      opacity: 0,
      duration: 1,
      y: 50,
      delay: -1,
      stagger:0.1,
      ease: "power4.out",
    });
  })

  tl.fromTo(".hero-footer",
    {
      opacity:0,
      scale:0,
      transformOrigin:"left",
    },{
      opacity:1,
      scale:1,
      duration:1.5,
      delay:-1.65,
      stagger:0.2,
      ease:"power4.inOut",
    }
  )

  const bannerImage = document.querySelectorAll(".banner-img");
  bannerImage && tl.from(bannerImage, {
    opacity: 0,
    // y: 30,
    duration: 1,
    delay: -1.7,
    stagger:0.1,
    ease:"power4.in",
  });
}
//======= BANNER CONTENT ANIMATION END =========

//====== TOGGLE MOBILE SUBMENU START ==========
const mobileMenuLinks = document.querySelectorAll(".mobile-menu__item");
const mobileMenuLinksArr = Array.from(mobileMenuLinks);
const hamburgerBtn = document.getElementById("menuToggle");
const mobileMenu = document.querySelector(".aside-mobile");

const tl = gsap.timeline();
hamburgerBtn.addEventListener('click', function(){
  this.classList.toggle("active");
  mobileMenu.classList.toggle("show");
  mobileMenuLinksArr.forEach((mobileLink)=>{
      gsap.fromTo(mobileLink,
        {
          opacity:0,
          y:50,
        },{
          opacity:1,
          y:0,
          duration:1,
          stagger:1,
          ease:"power4.inOut"
        }
      );
  });

  tl.fromTo(".socials__item", 
    {
      opacity:0,
      y:40,
    },{
      opacity:1,
      y:0,
      stagger:0.2,
      delay:-0.1,
      duration:1,
      ease:"power4.inOut",
    }
  )
  !isOpened ? stopLenisScroll() : startLenisScroll();
});

const menuLinks = document.querySelectorAll(".mobile-menu__link");
menuLinks.forEach((link)=>{
  link.addEventListener("click",()=>{
    mobileMenu.classList.remove("show");
    hamburgerBtn.classList.remove("active");
    !isOpened ? stopLenisScroll() : startLenisScroll();
  })
})

//====== TOGGLE MOBILE SUBMENU END ==========

//======== ACCORDION TOGGLE START ========
let content;
function toggleAccordion(element){ 
  element.classList.toggle("is-open");
  content = element.nextElementSibling;
  if(content){
    const isOpening = content.style.maxHeight;
    content.style.maxHeight = isOpening ? null : `${content.scrollHeight}px`;
    gsap.fromTo(content.children, 
      { opacity: 0, y:50 },
      { opacity: 1, y:0, duration:0.75, stagger:0.2, ease:"power4.out"}
    );
  }
}

const accordionBtns = document.querySelectorAll(".accordion-title");
accordionBtns && accordionBtns.forEach((accordion) => {
  accordion.addEventListener("click",function (e){
    e.stopPropagation();
    toggleAccordion(accordion);
    accordionBtns.forEach(otherAccordion => {
      if(otherAccordion !== accordion) {
        otherAccordion.classList.remove("is-open");
        otherAccordion.nextElementSibling.style.maxHeight = null;
      }
    });
  });
});

const mobileSubmenus = document.querySelectorAll(".mobileSubmenu");
mobileSubmenus.forEach((mobileSubmenu)=>{
  mobileSubmenu.addEventListener("click", function(){
    toggleAccordion(this)
  });
});
//======== ACCORDION TOGGLE END ========

//======= FLOATING INPUT LABLE START ======
document.querySelectorAll(".form__control").forEach((input) => {
  input.addEventListener("focus", () => input.nextElementSibling.classList.add("focused"))
  input.addEventListener("blur", () => input.nextElementSibling.classList.toggle("focused", input.value !== ""));
}); 
//======= FLOATING INPUT LABLE END ======

//====== ANIMATION SCRIPT START =========
const textContainers = gsap.utils.toArray(".fade-up");
textContainers.forEach((textContainer, i) => {
  gsap.fromTo(textContainer,
    { opacity: 0, y: 50 },
    { opacity: 1, y: 0, duration: 1, stagger:0.2, ease:"power2.out",
      scrollTrigger:{
        trigger: textContainer,
        toggleActions: "play none none none",
        once: true
      }
    }
  );
});

const fadeIn = gsap.utils.toArray(".fade-in");
fadeIn.forEach((mainContent, i) => {
  const anim = gsap.fromTo(mainContent,
    { opacity: 0 },
    { opacity: 1, duration: 1, ease: "power2.in",
       scrollTrigger:{
        trigger: mainContent,
        toggleActions: "play none none none",
        once: true
      }
    }
  );
});
//====== ANIMATION SCRIPT END =========

const dividers = gsap.utils.toArray(".divider");
dividers.forEach((divider, i)=>{
  const anim = gsap.fromTo(divider,
    { opacity:0, width:"0%", transformOrigin:"left"},
    { opacity:1, width:"100%", duration:1.5, ease:"power4.inOut"}
  )
  ScrollTrigger.create({
    trigger: divider,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1.5,
    // delay:-0.1,
    stagger:0.1,
    ease: "power4.inOut",
  });
})
  
window.addEventListener("load",()=>{
  hideLoader();
  bannerContentsAnimation();
});

// Lenis scroll event
const onLenisScroll =()=>{
  // checkScroll();
  activeLink();
  ScrollTrigger.update();
}

lenis.on('scroll',onLenisScroll);

// Sync Lenis with GSAP
gsap.ticker.add((time)=>{
  lenis.raf(time * 1000);
});

// Disable GSAP lag smoothing for better performance
gsap.ticker.lagSmoothing(0);